import { createSlice } from "@reduxjs/toolkit";

export const subCategoriesSlice = createSlice({
    name: "subCategories",
    initialState: {
        subCategories: []
    },

    reducers: {
        getAllSubCategories: (state, action) => {
            state.subCategories = action.payload;
        },
    },
});

export const { getAllSubCategories } = subCategoriesSlice.actions;

export default subCategoriesSlice.reducer;